var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBxWomen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "a5b6c6cc-9ac2-4fc0-bd71-886d9727800f",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a6bd11ae-ea35-464c-94d9-bd265cda9357",
    "data-name": "Path 89",
    d: "M14.445,7.461a4.445,4.445,0,1,0-5.276,4.365v1.7h-.96a.831.831,0,0,0,0,1.662h.961v.966a.831.831,0,0,0,1.662,0v-.966h.96a.831.831,0,0,0,0-1.662h-.961v-1.7a4.451,4.451,0,0,0,3.614-4.365m-7.228,0A2.783,2.783,0,1,1,10,10.243h0A2.785,2.785,0,0,1,7.217,7.461",
    style: {
      fill: "#005a7d"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxWomen);
export default __webpack_public_path__ + "static/media/bxWomen.50390b8c3028b346f9a8ce107e16c881.svg";
export { ForwardRef as ReactComponent };